export default {
  TITLE: '第三方SDK',
  CONTENT: `
  <h3>最后更新：2023年12月1日</h3>
  <p>我们收集的个人信息可能会使用第三方 SDK进行处理，以简化客户注册、发送推送通知、进行支付、统计数据，这些 SDK包括：</p>
  <h3>个推</h3>
  <h3>所属机构：每日互动股份有限公司</h3>
  <p>使用业务场景：推送通知</p>
  <p>收集的个人信息类型：应用列表信息、网络信息以及位置相关信息、设备信息：设备识别码、设备平台、设备厂商用于生成唯一的推送目标ID（CID）和设备ID（GID）</p>
  <p>功能：使用设备信息进行通知推送</p>
  <p>隐私保护说明：<a data-path="https://www.getui.com/privacy">https://www.getui.com/privacy</a></p>
  <h3>微信</h3>
  <h3>所属机构：深圳市腾讯计算机系统有限公司</h3>
  <p>使用业务场景：支付和登录支持</p>
  <p>收集的个人信息类型：个人常用设备信息</p>
  <p>功能：使用设备信息支持微信支付和登录</p>
  <p>隐私保护说明：<a data-path="https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl">https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl</a></p>
  <h3>支付宝</h3>
  <h3>所属机构：支付宝（中国）网络技术有限公司</h3>
  <p>使用业务场景：支付</p>
  <p>收集的个人信息类型：个人常用设备信息</p>
  <p>功能：使用设备信息支持支付宝支付</p>
  <p>隐私保护说明：<a data-path="https://render.alipay.com/p/c/k2cx0tg8">https://render.alipay.com/p/c/k2cx0tg8</a></p>
  <h3>TalkingData</h3>
  <h3>所属机构：北京腾云天下科技有限公司</h3>
  <p>使用业务场景：统计分析</p>
  <p>收集的个人信息类型：设备信息、IP地址信息、IDFA</p>
  <p>功能：用来统计APP行为的数量</p>
  <p>隐私保护说明：<a data-path="https://www.talkingdata.com/privacy.jsp?languagetype=zh_cn">https://www.talkingdata.com/privacy.jsp?languagetype=zh_cn</a></p>
  <p>SDK说明 :<a data-path="https://www.talkingdata.com/safety.jsp?languagetype=zh_cn">https://www.talkingdata.com/safety.jsp?languagetype=zh_cn</a></p>

  <h3>此外，个推SDK中集成了下列厂商SDK，详细信息如下：</h3>
  <h3>小米推送</h3>
  <p>所属机构：小米科技有限责任公司</p>
  <p>使用业务场景：对小米品牌的手机进行消息推送</p>
  <p>收集的个人信息类型：软件安装列表、个人常用设备信息</p>
  <p>功能：使用设备信息进行通知推送</p>
  <p>隐私保护说明：<a data-path="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a></p>

  <h3>VIVO 推送</h3>
  <p>所属机构：维沃移动通信有限公司</p>
  <p>所属机构：维沃移动通信有限公司</p>
  <p>使用业务场景：对VIVO品牌的手机进行消息推送</p>
  <p>收集的个人信息类型：本应用的运行中的进程</p>
  <p>功能：用于亚马逊海外购APP向VIVO手机用户推送消息</p>
  <p>隐私保护说明：<a data-path="https://dev.vivo.com.cn/documentCenter/doc/652#w1-12075822">https://dev.vivo.com.cn/documentCenter/doc/652#w1-12075822</a></p>

  <h3>OPPO 推送</h3>
  <p>所属机构：广东欧珀移动通信有限公司</p>
  <p>使用业务场景：对OPPO品牌的手机进行消息推送</p>
  <p>收集的个人信息类型：软件安装列表、个人常用设备信息</p>
  <p>功能：使用设备信息进行通知推送</p>
  <p>隐私保护说明：<a data-path="https://open.oppomobile.com/new/developmentDoc/info?id=10288">https://open.oppomobile.com/new/developmentDoc/info?id=10288</a></p>

  <h3>魅族推送</h3>
  <p>所属机构：珠海市魅族通讯设备有限公司</p>
  <p>使用业务场景：对魅族品牌的手机进行消息推送</p>
  <p>收集的个人信息类型[XX1] ：外部存储（SD卡数据）、运营商信息</p>
  <p>功能：用于亚马逊海外购APP向魅族手机用户推送消息</p>
  <p>隐私保护说明：<a data-path="https://static.meizu.com/resources/term/privacy8.html">https://static.meizu.com/resources/term/privacy8.html</a></p>

  <h3>华为推送</h3>
  <p>所属机构：华为软件技术有限公司</p>
  <p>使用业务场景：对华为品牌的手机进行消息推送</p>
  <p>收集的个人信息类型[XX1]：AndroidID、BSSID、网络信息、运营商信息、本应用运行中进程</p>
  <p>功能：用于亚马逊海外购APP向华为手机用户推送消息</p>
  <p>隐私保护说明：<a data-path="https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177">https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177</a></p>

  <h3>荣耀推送</h3>
  <p>所属机构：荣耀终端有限公司</p>
  <p>使用业务场景：对荣耀品牌的手机进行消息推送</p>
  <p>收集的个人信息类型：本应用的运行中进程</p>
  <p>功能：用于亚马逊海外购APP向荣耀手机用户推送消息</p>
  <p>隐私保护说明：<a data-path="https://developer.hihonor.com/cn/kitdoc?category=%E5%9F%BA%E7%A1%80%E6%9C%8D%E5%8A%A1&kitId=11002&navigation=guides&docId=sdk-data-security.md&token=">https://developer.hihonor.com/cn/kitdoc?category=%E5%9F%BA%E7%A1%80%E6%9C%8D%E5%8A%A1&kitId=11002&navigation=guides&docId=sdk-data-security.md&token=</a></p>
  `
};
